import script from "./NavBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBtn.vue?vue&type=script&setup=true&lang=js"

import "./NavBtn.vue?vue&type=style&index=0&id=7222ee86&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7222ee86"]])

export default __exports__